import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useTheme } from 'styled-components'
import { useDispatch } from 'react-redux'
import { Tonality } from '@dsny/dsny-component-library'
import { Keyboardarrowright, Logout } from '@dsny/dsny-component-library/icons'
import { MenuList, MenuItem, Footer } from './MobileAccountMenu.styles'
import ModalActions from 'reducers/Modal'

export const MobileAccountMenu = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const theme = useTheme()

  const handleSignout = useCallback(() => {
    dispatch(ModalActions.toggleSignoutModal())
  }, [])

  return (
    <>
      <Tonality.UIHeading
        headingStyle="headline5"
        color={theme.colors.neutralW90}
        style={{ padding: '24px 0', display: 'flex' }}
      >
        {t('home.account')}
      </Tonality.UIHeading>

      <MenuList>
        <MenuItem onClick={() => navigate('/profile')}>
          {t('home.profile')}
          <Keyboardarrowright
            width={20}
            height={20}
            color={theme.colors.neutralW90}
          />
        </MenuItem>

        <MenuItem onClick={() => navigate('/my-network')}>
          {t('network.my-network')}
          <Keyboardarrowright
            width={20}
            height={20}
            color={theme.colors.neutralW90}
          />
        </MenuItem>

        <MenuItem onClick={() => navigate('/account-management')}>
          {t('home.account-management')}
          <Keyboardarrowright
            width={20}
            height={20}
            color={theme.colors.neutralW90}
          />
        </MenuItem>

        <MenuItem onClick={() => navigate('/settings-preferences')}>
          {t('home.settings-preferences')}
          <Keyboardarrowright
            width={20}
            height={20}
            color={theme.colors.neutralW90}
          />
        </MenuItem>
      </MenuList>

      <Tonality.UIText
        textStyle="body"
        color={theme.colors.neutralW60}
        onClick={handleSignout}
        style={{
          marginTop: 32,
          display: 'flex',
          alignItems: 'center',
          justifySelf: 'center',
          gap: 8
        }}
      >
        <Logout width={16} height={16} color={theme.colors.neutralW60} />
        {t('home.sign-out')}
      </Tonality.UIText>

      <Footer>
        <span>{t('general.support')}</span>
        <span>{t('general.privacy')}</span>
        <span>{t('general.company')}</span>
      </Footer>
    </>
  )
}
